export default __webpack_public_path__ + "static/LGP Vertical – Primary – 800x400-7673b1490069d3790158ace4cfee52a8.svg";